module.exports = __webpack_public_path__ + "img/user.442b0eb2.svg";